/*! npm.im/supports-webp */
'use strict';

var canvas = document.createElement('canvas');
canvas.width = canvas.height = 1;
var index = canvas.toDataURL && canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;

module.exports = index;


//////////////////
// WEBPACK FOOTER
// ../~/supports-webp/dist/supports-webp.common-js.js
// module id = 458
// module chunks = 1